<!--
  Модалка массовой смены категории у выбранных расходов
-->
<template>
  <BaseModal
    :visible="true"
    title="Изменить категорию"
    size="md"
    footer-align="start"
    elevated-footer
    @close="$emit('close')"
  >
    <form
      id="bulk-change-category-form"
      @submit.prevent="handleSubmit"
      class="modal-form"
    >
      <p class="info-text">
        Выбрано расходов:
        <strong>{{ expenses.length }}</strong>
      </p>

      <!-- Новая категория применяется ко всем выбранным расходам -->
      <BaseFormField
        label="Новая категория"
        for-id="new-category"
        required
        :filled="!!newCategoryId"
        :error="hasError"
      >
        <expense-category-select
          id="new-category"
          v-model="newCategoryId"
          placeholder="Выберите категорию"
          :clearable="false"
          :invalid="hasError"
          @update:modelValue="hasError = false"
        />
      </BaseFormField>
    </form>

    <template #footer>
      <base-primary-button
        type="submit"
        form="bulk-change-category-form"
        :disabled="isSubmitting"
        class="form-btn"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Применить</span>
      </base-primary-button>
      <base-button
        type="button"
        @click="$emit('close')"
        class="form-btn"
        :disabled="isSubmitting"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import { getCompanyId } from "@/utils/userUtils";
import { useNotificationStore } from "@/stores/notificationStore";
import expensesApi from "@/services/api/expensesApi";
import ExpenseCategorySelect from "@/components/Expense/ExpenseCategorySelect.vue";

export default {
  name: "BulkChangeCategoryModal",
  components: {
    ExpenseCategorySelect,
  },
  props: {
    expenses: {
      type: Array,
      required: true,
    },
  },
  emits: ["close", "changed"],
  data() {
    return {
      newCategoryId: null,
      hasError: false,
      isSubmitting: false,
      companyId: getCompanyId(),
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.newCategoryId) {
        this.hasError = true;
        return;
      }

      const notificationStore = useNotificationStore();

      try {
        this.isSubmitting = true;

        const responses = await Promise.all(
          this.expenses.map((expense) =>
            expensesApi.update(this.companyId, expense.id, {
              expense_category_id: this.newCategoryId,
            })
          )
        );

        const updatedExpenses = responses.map((r) => r.data.result);

        notificationStore.showSuccess(
          `Категория изменена у ${this.expenses.length} расходов`
        );

        this.$emit("changed", updatedExpenses);
      } catch (error) {
        console.error("Ошибка при массовой смене категории:", error);
        notificationStore.showError("Не удалось изменить категорию");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-form {
  display: flex;
  flex-direction: column;
}

.info-text {
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
}

@media screen and (max-width: 767px) {
  .form-btn {
    flex: 1;
  }
}
</style>
